const PREFIX_URL: string = '' // Proxied through Next.js rewrites in next.config.ts
// const PREFIX_URL: string = 'http://127.0.0.1:8000'
export  {PREFIX_URL }
